import { render, staticRenderFns } from "./StudentFinder.vue?vue&type=template&id=567032f4"
import script from "./StudentFinder.vue?vue&type=script&lang=js"
export * from "./StudentFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports